<template>
  <div class="main-component homes1">
    <div class="wrap">
      <Row :gutter="50" class="list">
        <Col span="6">
          <div
            class="item"
            @mouseenter="currentIdx = 1"
            @mouseleave="currentIdx = 0"
          >
            <img src="~@/assets/images/jinkoushuilv.png" alt="" />
            <div
              class="title lk"
              @click="
                $router.push({
                  name: 'queryRateI',
                  params: { exporter: 1, importer: 1, hscode: 1 }
                })
              "
            >
              进口税率
            </div>
            <div class="desc lk">
              <div
                @click="
                  $router.push({
                    name: 'queryRateI',
                    params: { exporter: 1, importer: 1, hscode: 1 }
                  })
                "
              >
                RCEP税率
              </div>
              <div
                @click="
                  $router.push({
                    name: 'queryRateI',
                    params: { exporter: 1, importer: 1, hscode: 1 }
                  })
                "
              >
                其他FTA税率
              </div>
            </div>
            <div class="desc lk">
              <div
                @click="
                  $router.push({
                    name: 'queryRateI',
                    params: { exporter: 1, importer: 1, hscode: 1 }
                  })
                "
              >
                税率比较
              </div>
              <div
                @click="
                  $router.push({
                    name: 'queryRateI',
                    params: { exporter: 1, importer: 1, hscode: 1 }
                  })
                "
              >
                税费预估
              </div>
            </div>
            <div class="rcep-popup-arrow" v-show="currentIdx == 1"></div>
            <div class="rcep-popup" v-show="currentIdx == 1">
              <div class="funs-main">
                <Row :gutter="60">
                  <Col span="12">
                    <div class="s1">
                      <div class="stitle qyxq">
                        企业需求
                        <div
                          class="btn"
                          @click="
                            $router.push({
                              name: 'queryRateI',
                              params: { exporter: 1, importer: 1, hscode: 1 }
                            })
                          "
                        >
                          查询
                        </div>
                      </div>
                      <div
                        class="sdesc"
                        style="text-indent: 30px;padding-left: 0;left: -12px;"
                      >
                        我国有20套FTA在实施，全球有近400套FTA。每套FTA都会要求成员方在一定时期内逐步实现90%以上商品的零关税减让。各FTA的降税模式不同，各成员方的降税速度不同，因此企业在进出口一项商品时，需要查询和确定可以合法适用的最低关税，降低贸易成本，提高竞争力。
                      </div>
                      <div class="stitle gnsm" style="margin-top: 20px;">
                        功能说明
                      </div>
                      <div class="sdesc num">
                        <span class="sn1">-</span
                        >在进口商品时，从最惠国税率、暂定税率、FTA协定税率等多种税率中帮企业找到最低关税，并精准计算税费；
                      </div>
                      <div class="sdesc num">
                        <span class="sn1">-</span
                        >在出口商品时，帮助企业了解目的国（地区）是否有FTA协定关税，以及该商品可适用的最低税率，并精准计算税费；
                      </div>
                      <div class="sdesc num">
                        <span class="sn1">-</span
                        >一键计算关税成本、增值税、消费税成本，以及每票货物通过应用FTA优惠政策可以获得的节税金额；
                      </div>
                      <div class="sdesc num">
                        <span class="sn1">-</span
                        >在进出口中，如果有多套FTA税率可以适用，将全量收集所有FTA的协定税率信息，并通过比较帮忙企业选择应适用的FTA类型及对应的最低税率；
                      </div>
                      <div class="sdesc num">
                        <span class="sn1">-</span
                        >对于没有FTA优惠关税的商品，系统自动提醒其它20套FTA所涉及的国家（地区）及协定税率，便于企业考虑是否通过扩大供应商来源或者调整采购渠道来享受优惠税率。
                      </div>
                    </div>
                  </Col>
                  <Col span="12">
                    <div class="s2">
                      <div class="stitle gnld">功能亮点</div>
                      <div class="sdesc">
                        <b><span>-</span>税则转版。</b
                        ><span>-</span
                        >通过海关专家团队对各国税则的专业分析，按照各FTA成员国的最新进出口税号匹配最优税率。RCEP的降税清单是各成员国基于2012年谈判时的税则版本，与2022年实施的最新税则相比已产生了巨大差异，很多原税号已经没有或者变更。本系统对所有FTA税则进行转版和税号更新，降低企业查询难度，提高查询准确性。
                      </div>
                      <div class="sdesc">
                        <b><span>-</span>一键查询。</b
                        ><span>-</span
                        >RCEP协定的大多数成员与中国有多套同时实施的FTA（如韩国、新加坡、柬埔寨和中国有3套同时适用的FTA），每套FTA在当年的降税幅度不同，企业需要查询到所有可适用的协定税率，并比较特定税号的商品在不同FTA中的优惠税率，才能选出最优关税。本系统可以根据商品税号一键查询所有可适用的FTA优惠关税信息，以最新2022年税则为依据为企业推荐最低税率。
                      </div>
                      <div class="sdesc">
                        <b><span>-</span>税费预估。</b
                        ><span>-</span
                        >根据企业选择的FTA及相应税率，企业可以轻松对比各项FTA政策带来的关税节省效益。
                      </div>
                      <div class="sdesc">
                        <b><span>-</span>推荐和特定商品相关的所有FTA信息。</b
                        ><span>-</span
                        >根据企业录入的特定国别（地区），系统优先推荐可适用的FTA协定税率，同时会推荐其它和中国签署FTA协定并给与优惠关税的国别信息及相应的协定关税，符合企业管理需求，可以开展综合研判。
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </Col>
        <Col span="6">
          <div
            class="item"
            @mouseenter="currentIdx = 1"
            @mouseleave="currentIdx = 0"
          >
            <img src="~@/assets/images/chukoushuilv.png" alt="" />
            <div
              class="title lk"
              @click="
                $router.push({
                  name: 'queryRateE',
                  params: { exporter: 1, importer: 1, hscode: 1 }
                })
              "
            >
              出口税率
            </div>
            <div class="desc lk">
              <div
                @click="
                  $router.push({
                    name: 'queryRateE',
                    params: { exporter: 1, importer: 1, hscode: 1 }
                  })
                "
              >
                RCEP税率
              </div>
              <div
                @click="
                  $router.push({
                    name: 'queryRateE',
                    params: { exporter: 1, importer: 1, hscode: 1 }
                  })
                "
              >
                其他FTA税率
              </div>
            </div>
            <div class="desc lk">
              <div
                @click="
                  $router.push({
                    name: 'queryRateE',
                    params: { exporter: 1, importer: 1, hscode: 1 }
                  })
                "
              >
                税率比较
              </div>
              <div
                @click="
                  $router.push({
                    name: 'queryRateE',
                    params: { exporter: 1, importer: 1, hscode: 1 }
                  })
                "
              >
                税费预估
              </div>
            </div>
            <div class="rcep-popup-arrow" v-show="currentIdx == 1"></div>
            <div class="rcep-popup" v-show="currentIdx == 1">
              <div class="funs-main">
                <Row :gutter="60">
                  <Col span="12">
                    <div class="s1">
                      <div class="stitle qyxq">
                        企业需求
                        <div
                          class="btn"
                          @click="
                            $router.push({
                              name: 'queryRateE',
                              params: { exporter: 1, importer: 1, hscode: 1 }
                            })
                          "
                        >
                          查询
                        </div>
                      </div>
                      <div
                        class="sdesc"
                        style="text-indent: 30px;padding-left: 0;left: -12px;"
                      >
                        我国有20套FTA在实施，全球有近400套FTA。每套FTA都会要求成员方在一定时期内逐步实现90%以上商品的零关税减让。各FTA的降税模式不同，各成员方的降税速度不同，因此企业在进出口一项商品时，需要查询和确定可以合法适用的最低关税，降低贸易成本，提高竞争力。
                      </div>
                      <div class="stitle gnsm" style="margin-top: 20px;">
                        功能说明
                      </div>
                      <div class="sdesc num">
                        <span class="sn1">-</span
                        >在进口商品时，从最惠国税率、暂定税率、FTA协定税率等多种税率中帮企业找到最低关税，并精准计算税费；
                      </div>
                      <div class="sdesc num">
                        <span class="sn1">-</span
                        >在出口商品时，帮助企业了解目的国（地区）是否有FTA协定关税，以及该商品可适用的最低税率，并精准计算税费；
                      </div>
                      <div class="sdesc num">
                        <span class="sn1">-</span
                        >一键计算关税成本、增值税、消费税成本，以及每票货物通过应用FTA优惠政策可以获得的节税金额；
                      </div>
                      <div class="sdesc num">
                        <span class="sn1">-</span
                        >在进出口中，如果有多套FTA税率可以适用，将全量收集所有FTA的协定税率信息，并通过比较帮忙企业选择应适用的FTA类型及对应的最低税率；
                      </div>
                      <div class="sdesc num">
                        <span class="sn1">-</span
                        >对于没有FTA优惠关税的商品，系统自动提醒其它20套FTA所涉及的国家（地区）及协定税率，便于企业考虑是否通过扩大供应商来源或者调整采购渠道来享受优惠税率。
                      </div>
                    </div>
                  </Col>
                  <Col span="12">
                    <div class="s2">
                      <div class="stitle gnld">功能亮点</div>
                      <div class="sdesc">
                        <b><span>-</span>税则转版。</b
                        ><span>-</span
                        >通过海关专家团队对各国税则的专业分析，按照各FTA成员国的最新进出口税号匹配最优税率。RCEP的降税清单是各成员国基于2012年谈判时的税则版本，与2022年实施的最新税则相比已产生了巨大差异，很多原税号已经没有或者变更。本系统对所有FTA税则进行转版和税号更新，降低企业查询难度，提高查询准确性。
                      </div>
                      <div class="sdesc">
                        <b><span>-</span>一键查询。</b
                        ><span>-</span
                        >RCEP协定的大多数成员与中国有多套同时实施的FTA（如韩国、新加坡、柬埔寨和中国有3套同时适用的FTA），每套FTA在当年的降税幅度不同，企业需要查询到所有可适用的协定税率，并比较特定税号的商品在不同FTA中的优惠税率，才能选出最优关税。本系统可以根据商品税号一键查询所有可适用的FTA优惠关税信息，以最新2022年税则为依据为企业推荐最低税率。
                      </div>
                      <div class="sdesc">
                        <b><span>-</span>税费预估。</b
                        ><span>-</span
                        >根据企业选择的FTA及相应税率，企业可以轻松对比各项FTA政策带来的关税节省效益。
                      </div>
                      <div class="sdesc">
                        <b><span>-</span>推荐和特定商品相关的所有FTA信息。</b
                        ><span>-</span
                        >根据企业录入的特定国别（地区），系统优先推荐可适用的FTA协定税率，同时会推荐其它和中国签署FTA协定并给与优惠关税的国别信息及相应的协定关税，符合企业管理需求，可以开展综合研判。
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </Col>
        <Col span="6">
          <div
            class="item"
            @mouseenter="currentIdx = 2"
            @mouseleave="currentIdx = 0"
          >
            <img src="~@/assets/images/new_home/ss2.png" alt="" />
            <div class="title lk" @click="gotoHs">税则信息</div>
            <div class="desc lk">
              <div @click="gotoHs">海关编码</div>
              <div @click="gotoHs">监管证件</div>
            </div>
            <div class="desc lk">
              <div @click="gotoHs">检验检疫</div>
              <div @click="gotoHs">中美加征</div>
            </div>
            <div class="rcep-popup-arrow" v-show="currentIdx == 2"></div>
            <div class="rcep-popup" v-show="currentIdx == 2">
              <div class="funs-main">
                <Row :gutter="60">
                  <Col span="12">
                    <div class="s1">
                      <div class="stitle qyxq">
                        企业需求
                        <div class="btn" @click="gotoHs">查询</div>
                      </div>
                      <div
                        class="sdesc"
                        style="text-indent: 30px;padding-left: 0;left: -12px;"
                      >
                        每个国家（以及单独关税区）都会制定进出口管制政策，对商品实行禁止类、限制类和自由类不同的市场准入管理。企业在进出口时，需要了解相关商品所涉及的贸易管制要求，准备相应的进出口许可证、检验检疫证明，才能合法合规的从事进出口活动，享受相应的通关便利待遇。
                      </div>
                      <div class="stitle gnsm" style="margin-top: 20px;">
                        功能说明
                      </div>
                      <div class="sdesc num">
                        <span class="sn1">-</span
                        >查询特定税号下的商品所要提供的监管证件类型（如关税配额证明、两用物项和技术许可证、濒危动植物许可证、药品进出口准许证等近60种证件），并提示每项监管证件的签发机构。
                      </div>
                      <div class="sdesc num">
                        <span class="sn1">-</span
                        >对于特定税号下的商品，提示进口和出口中涉及的食品、动植物、卫生检疫证件要求，以及商品检验证件的要求；
                      </div>
                      <div class="sdesc num">
                        <span class="sn1">-</span
                        >对于特定商品，如果涉及出口税率、出口退税，或者反倾销反补贴税率，将一站式展示相关税费信息；
                      </div>
                      <div class="sdesc num">
                        <span class="sn1">-</span
                        >提供中美加征税率的及时更新，并对加征的实施时间和结束时间给出指南和参考。
                      </div>
                    </div>
                  </Col>
                  <Col span="12">
                    <div class="s2">
                      <div class="stitle gnld">功能亮点</div>
                      <div class="sdesc">
                        <b><span>-</span>最新税号的转版与匹配。</b
                        ><span>-</span
                        >每个国家的税则都会动态调整，与之对应的监管证件也要随之更新。本系统会根据2022年最新税则对每个税号所应对的监管证件和检验检疫证明持续更新，保持数据的准确性和及时性。
                      </div>
                      <div class="sdesc">
                        <b><span>-</span>一键查询。</b
                        ><span>-</span
                        >企业只需要输入商品所应对的税号，便可以一键查询到所有影响进出口的监管政策，包括许可证件、出口税费、中美加征、反倾销反补贴、增值税、消费税等一揽子贸易政策信息。
                      </div>
                      <div class="sdesc">
                        <b><span>-</span>海关编码智能检索。</b
                        ><span>-</span>对于不了解海关编码（HS
                        Code）的企业，可以输入中文，系统可以智能提供税号检索功能，协助企业查询商品所对应的最新版海关编码。
                      </div>
                      <div class="sdesc">
                        <b><span>-</span>信息与监管部门同步。</b
                        ><span>-</span
                        >通过专家团队持续的信息收集与整理，及时更新本系统中的国际贸易监管政策与关税信息，保持和海关与口岸监管部门所执行的贸易政策同步，满足企业的进出口实操要求。
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </Col>
        <Col span="6">
          <div
            class="item"
            @mouseenter="currentIdx = 3"
            @mouseleave="currentIdx = 0"
          >
            <img src="~@/assets/images/new_home/ss3.png" alt="" />
            <div
              class="title lk"
              @click="
                $router.push({
                  name: 'queryRules',
                  params: { exporter: 1, importer: 1, hscode: 1 }
                })
              "
            >
              原产地规则
            </div>
            <div class="desc lk">
              <div
                @click="
                  $router.push({
                    name: 'queryRules',
                    params: { exporter: 1, importer: 1, hscode: 1 }
                  })
                "
              >
                享惠条件
              </div>
              <div
                @click="
                  $router.push({
                    name: 'queryRules',
                    params: { exporter: 1, importer: 1, hscode: 1 }
                  })
                "
              >
                累积规则
              </div>
            </div>
            <div class="desc lk">
              <div
                @click="
                  $router.push({
                    name: 'queryRules',
                    params: { exporter: 1, importer: 1, hscode: 1 }
                  })
                "
              >
                原产地证
              </div>
              <div
                @click="
                  $router.push({
                    name: 'queryRules',
                    params: { exporter: 1, importer: 1, hscode: 1 }
                  })
                "
              >
                方案推荐
              </div>
            </div>
            <div class="rcep-popup-arrow" v-show="currentIdx == 3"></div>
            <div class="rcep-popup" v-show="currentIdx == 3">
              <div class="funs-main">
                <Row :gutter="60">
                  <Col span="12">
                    <div class="s1">
                      <div class="stitle qyxq">
                        企业需求
                        <div
                          class="btn"
                          @click="
                            $router.push({
                              name: 'queryRules',
                              params: { exporter: 1, importer: 1, hscode: 1 }
                            })
                          "
                        >
                          查询
                        </div>
                      </div>
                      <div
                        class="sdesc"
                        style="text-indent: 30px;padding-left: 0;left: -12px;"
                      >
                        每项出口商品如果要在成员国享受RCEP或者其它FTA的优惠关税待遇，需要满足一个重要的前提条件，即该商品要符合特定FTA的原产地规则。原产地规则由一系列法律条款和专业术语构成，商品必须符合这些原产地规则并出具原产地证明才可以在目的国（地区）享受优惠关税待遇。并非从RCEP或FTA成员方出口的商品就可以自动享受FTA协定关税。FTA协定税率目前在各成员方均不是默认给与。
                      </div>
                      <div class="stitle gnsm" style="margin-top: 20px;">
                        功能说明
                      </div>
                      <div class="sdesc num">
                        <span class="sn1">-</span
                        >精准提供全套原产地规则。根据企业的实际情况，通过大数据技术可精准的提供所有需要满足的原产地规则和条款，包括对原产地标准、补充规则、附加规则和海关手续上的要求。提高企业在上百页文件中搜索法律规则的效率，降低合规管理成本；
                      </div>
                      <div class="sdesc num">
                        <span class="sn1">-</span
                        >方案比较和推荐。根据商品情况定制方案。针对每一家企业的每一个特定商品提供原产地规则分析，不符合某套FTA原产地规则的商品，可以推荐另外一套FTA原产地规则。通过智能提醒帮助企业应用累积规则，提高FTA优惠关税利用率。
                      </div>
                      <div class="sdesc num">
                        <span class="sn1">-</span
                        >原产地证明指南。提供各套FTA的原产地证明申请和填制指南，协助企业便捷取得国际贸易“纸黄金”。
                      </div>
                    </div>
                  </Col>
                  <Col span="12">
                    <div class="s2">
                      <div class="stitle gnld">功能亮点</div>
                      <div class="sdesc">
                        <b><span>-</span>合规节税。</b
                        ><span>-</span
                        >各套FTA原产地规则所涉及的法律条款专业且复杂，如对税则归类改变、加工工艺和增值百分比的要求，对包装、附件和可互换材料的要求，对运输和仓储的要求，以及对海关手续和提交单证的要求，这一系列要求和标准不易于理解和应用。企业一旦理解有偏差或者适用出现错误，就会面临被海关稽查的风险，同时出口商品还会面临被国外海关和贸易监管部门处罚的风险。本系统可以提高企业的合规能力，放心无忧的使用优惠关税。
                      </div>
                      <div class="sdesc">
                        <b><span>-</span>国际信用资质提升。</b
                        ><span>-</span
                        >本系统的原产地规则查询和判定功能，可支撑企业申请”经核准出口商资质”，并在RCEP各成员国互认，企业可自主签发原产地声明并在各成员国享受优惠关税。
                      </div>
                      <div class="sdesc">
                        <b><span>-</span>根据最新税则匹配原产地规则。</b
                        ><span>-</span
                        >每个国家的税则都会动态调整，与之对应的原产地规则也要及时和动态更新。本系统会根据2022年最新税则对每个税号所应对的原产地规则持续更新，帮助企业了解最新税则所对应的原产地规则与全套享惠方案。
                      </div>
                      <div class="sdesc">
                        <b><span>-</span>享惠方案智能比较。</b
                        ><span>-</span
                        >对于一项商品，如果涉及多套FTA，可以快速查询各套原产地规则，并协助企业实现原产地严格度的比较。
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <Row :gutter="50" class="list" style="margin-top: 40px">
        <Col span="6">
          <div
            class="item"
            @mouseenter="currentIdx = 4"
            @mouseleave="currentIdx = 0"
          >
            <img src="~@/assets/images/new_home/ss4.png" alt="" />
            <div
              class="title lk"
              @click="$router.push({ name: 'RulesDecide' })"
            >
              原产地判定
            </div>
            <div class="desc lk">
              <div @click="$router.push({ name: 'RulesDecide' })">一键判定</div>
              <div @click="$router.push({ name: 'RulesDecide' })">生产优化</div>
            </div>
            <div class="desc lk">
              <div @click="$router.push({ name: 'RulesDecide' })">批量应用</div>
              <div @click="$router.push({ name: 'RulesDecide' })">信息追溯</div>
            </div>
            <div class="rcep-popup-arrow" v-show="currentIdx == 4"></div>
            <div class="rcep-popup" v-show="currentIdx == 4">
              <div class="funs-main">
                <Row :gutter="60">
                  <Col span="12" style="border-right:0.5px solid #ffa000">
                    <div class="s1">
                      <div class="stitle qyxq">
                        企业需求
                        <div
                          class="btn"
                          @click="$router.push({ name: 'RulesDecide' })"
                        >
                          查询
                        </div>
                      </div>
                      <div
                        class="sdesc"
                        style="text-indent: 30px;padding-left: 0;left: -12px;"
                      >
                        对于汽车、航空、医药、化工等复杂工艺的行业，一项产品的生产可能涵盖几十个甚至上百个零部件的组装，涉及十几个国家的分工合作与参与。同时，一项产品的原材料和零部件价格会发生变化、供应商会发生变化、汇率也会发生变化，这些因素都会随时影响原产地规则的适用结果，影响企业所生产制造的产品的原产地结果，以及享受FTA优惠关税的合法性。企业需要根据采购、生产、加工、物流仓储、销售分拨的经营变化，来及时做出原产地的判定结果，确定享受FTA优惠关税的合规方案。
                      </div>
                      <div class="stitle gnsm" style="margin-top: 20px;">
                        功能说明
                      </div>
                      <div class="sdesc num">
                        <span class="sn1">-</span
                        >智能判定。本系统通过AI算法将行业专家经验数字化，帮助企业快速判断一项产品是否符合原产地规则。企业只需要把原材料和零部件等信息录入系统，就可以分秒间得到原产地判定结果。
                      </div>
                      <div class="sdesc num">
                        <span class="sn1">-</span
                        >AI专家的咨询建议。对于经原产地判定不符合标准的产品，系统会模拟咨询专家指出问题所在，并提供改进和优化的建议。通过智能化咨询，可帮助企业优化采购、生产和销售策略，最大化享受FTA带来的降税红利。
                      </div>
                      <div class="sdesc num">
                        <span class="sn1">-</span
                        >原产地证明申请。企业对满足原产地规则的商品可以在线申请原产地证明，并获得优惠关税待遇。
                      </div>
                    </div>
                  </Col>
                  <Col span="12" style="border-left: 0 none">
                    <div class="s2">
                      <div class="stitle gnld">功能亮点</div>
                      <div class="sdesc">
                        <b><span>-</span>便捷获得专家在线服务。</b
                        ><span>-</span
                        >本系统缓解了企业尤其中小企业寻找关税专家的困难，企业可以在线获得有针对性的合规方案。
                      </div>
                      <div class="sdesc">
                        <b><span>-</span>提供所有满足享惠要求的方案。</b
                        ><span>-</span
                        >根据对RCEP以及每一套FTA原产地规则的法律条款，提供所有可以让企业享受优惠关税的可行性方案，最大化应用累积规则、微小含量等补充规则，综合应用扣减和累加等不同原产成分的计算方式，通过智能运算帮助企业尽享优惠政策。
                      </div>
                      <div class="sdesc">
                        <b><span>-</span>根据最新税则进行原产地判定计算。</b
                        ><span>-</span
                        >本系统会根据2022年最新税则及原产地规则对企业的进出口商品提供判定运算，保障判定结果的准确性。
                      </div>
                      <div class="sdesc">
                        <b><span>-</span>SKU级信息管理与追溯。</b
                        ><span>-</span
                        >本系统可以针对复杂产业链的商品实现SKU级别的商品信息管理，同时对于每一项商品的原产地判定结果可达到“可记录、可分析、可预警、可查询、可追溯”的信息化和数字化管理功能。
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </Col>
        <Col span="6">
          <div
            class="item"
            @mouseenter="currentIdx = 5"
            @mouseleave="currentIdx = 0"
          >
            <img src="~@/assets/images/new_home/ss5.png" alt="" />
            <div class="title lk" @click="$router.push({ name: 'OriginCert' })">
              原产地证明办理
            </div>
            <div class="desc lk">
              <div @click="$router.push({ name: 'OriginCert' })">在线申请</div>
              <div @click="$router.push({ name: 'OriginCert' })">专家咨询</div>
            </div>
            <div class="desc lk">
              <div @click="$router.push({ name: 'OriginCert' })">单证管理</div>
              <div @click="$router.push({ name: 'OriginCert' })">闭环服务</div>
            </div>
            <div class="rcep-popup-arrow" v-show="currentIdx == 5"></div>
            <div class="rcep-popup" v-show="currentIdx == 5">
              <div class="funs-main">
                <Row :gutter="60">
                  <Col span="12" style="border-right:0.5px solid #ffa000">
                    <div class="s1">
                      <div class="stitle qyxq">企业需求</div>
                      <div
                        class="sdesc"
                        style="text-indent: 30px;padding-left: 0;left: -12px;"
                      >
                        企业需要向海关提交合法有效的原产地证明文件才能在通关过程中实际享受到FTA协定关税待遇。原产地证明文件的类型较多，要填制的内容专业复杂，且各FTA采用的证书格式和填制规范不同，对于重办、补办等类型证书的效力也有多种手续上的合规要求。如果企业不了解相关条款和规则，提供了在格式、类型、版本、内容上存在错误的证书，会导致在通关中不能及时享受优惠关税，或者面临通关后被海关稽查的风险。
                      </div>
                      <div class="stitle gnsm" style="margin-top: 20px;">
                        功能说明
                      </div>
                      <div class="sdesc num">
                        <span class="sn1">-</span
                        >在线申请。与原产地判定功能应用相结合，可以为企业办理原产地证书提供一站式解决方案，经过智能判定达到标准的商品，在线直接向签证机构递交申请材料并获得原产地证书。
                      </div>
                      <div class="sdesc num">
                        <span class="sn1">-</span
                        >便捷制作申请材料。系统可以帮助企业将商品的相关信息上传至国际贸易单一窗口，免除二次录入的麻烦，提高办公效率。
                      </div>
                      <div class="sdesc num">
                        <span class="sn1">-</span
                        >单证合规管理与文档保存。帮助AEO企业，以及“经核准出口商”企业，对原产地证明文件进行单证之间的一致性校验，并归档留存相关材料。
                      </div>
                    </div>
                  </Col>
                  <Col span="12" style="border-left: 0 none">
                    <div class="s2">
                      <div class="stitle gnld">功能亮点</div>
                      <div class="sdesc">
                        <b><span>-</span>专家在线服务。</b
                        ><span>-</span
                        >通过智能客服与专家解答，帮助企业解决证书办理中的各种疑难问题。降低企业尤其中小企业寻找关税专家的成本，高效获得有针对性的享惠方案。
                      </div>
                      <div class="sdesc">
                        <b><span>-</span>最优关税的闭环服务。</b
                        ><span>-</span
                        >本系统通过提供税率查询、原产地判定和原产地证书办理等功能，可帮助企业优化享惠方案、满足原产地规则、取得原产地证明，一站式享受FTA便利待遇。
                      </div>
                      <div class="sdesc">
                        <b><span>-</span>“经核准出口商”资质的认证管理。</b
                        ><span>-</span
                        >根据RCEP等多个FTA的政策，允许有原产地规则合规管理能力的企业向海关申请“经核准出口商”资质，并自主出具原产地声明，不需要在每次出口货物时逐票向签证机构提供申请材料并办理证书。获得认证资质的企业，将在RCEP成员国之间互认该资质，在境外同样获得最大化通关便利。
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </Col>
        <Col span="6">
          <div
            class="item"
            @mouseenter="currentIdx = 6"
            @mouseleave="currentIdx = 0"
          >
            <img src="~@/assets/images/new_home/ss6.png" alt="" />
            <div
              class="title lk"
              @click="$router.push({ name: 'EnjoyDiscount' })"
            >
              企业享惠分析
            </div>
            <div class="desc lk">
              <div @click="$router.push({ name: 'EnjoyDiscount' })">
                享惠管理
              </div>
              <div @click="$router.push({ name: 'EnjoyDiscount' })">
                利用分析
              </div>
            </div>
            <div class="desc lk">
              <div @click="$router.push({ name: 'EnjoyDiscount' })">
                应享尽享
              </div>
              <div @click="$router.push({ name: 'EnjoyDiscount' })">
                智能报表
              </div>
            </div>
            <div class="rcep-popup-arrow" v-show="currentIdx == 6"></div>
            <div class="rcep-popup" v-show="currentIdx == 6">
              <div class="funs-main">
                <Row :gutter="60">
                  <Col span="12" style="border-right:0.5px solid #ffa000">
                    <div class="s1">
                      <div class="stitle qyxq">
                        企业需求
                        <div
                          class="btn"
                          @click="$router.push({ name: 'EnjoyDiscount' })"
                        >
                          查询
                        </div>
                      </div>
                      <div
                        class="sdesc"
                        style="text-indent: 30px;padding-left: 0;left: -12px;"
                      >
                        根据企业进出口的实际情况，通过事前、事中和事后三个阶段，帮助企业发现每一个商品的FTA协定关税的享惠机会，为企业带来最直观和最具有操作性的进出口享惠分析建议，并可以根据不同企业的管理需要制定个性化享惠报表。
                      </div>
                      <div class="stitle gnsm" style="margin-top: 20px;">
                        功能说明
                      </div>
                      <div class="sdesc num">
                        <span class="sn1">-</span
                        >对于企业计划要开展的进出口贸易，提供最大化享受优惠税率的节税预估与分析报表，提前做好利用预判和享惠计划。
                      </div>
                      <div class="sdesc num">
                        <span class="sn1">-</span
                        >对于已经开展的进出口贸易，针对历史数据进行分析，是否达到预期的节税计划，找到应享未享FTA协定关税的原因。
                      </div>
                      <div class="sdesc num">
                        <span class="sn1">-</span
                        >根据企业日常管理需求，针对特定料号、特定商品编码、特定贸易方式、特定国别、特定时间段、特定自贸协定等多种筛选条件和维度，定制生成享惠分析报表。
                      </div>
                    </div>
                  </Col>
                  <Col span="12" style="border-left: 0 none">
                    <div class="s2">
                      <div class="stitle gnld">功能亮点</div>
                      <div class="sdesc">
                        <b><span>-</span>精准计算应税金额。</b
                        ><span>-</span
                        >本系统可以综合考虑运费、保费和杂费等所有税费的影响因素与分摊规则，计算每票货物的税费成本。帮助企业精准预估在使用FTA最优税率情况下的贸易成本和节税金额。
                      </div>
                      <div class="sdesc">
                        <b><span>-</span>适用多种币值。</b
                        ><span>-</span
                        >企业可以根据贸易国别和管理习惯采用不同币值作为统计单位。
                      </div>
                      <div class="sdesc">
                        <b><span>-</span>定制化分析报表。</b
                        ><span>-</span
                        >可以根据不同行业的管理重点和目标，对不同国别、地区、商品品类、时间段和贸易金额进行综合分析。
                      </div>
                      <div class="sdesc">
                        <b><span>-</span>多维度满足企业管理需求。</b
                        ><span>-</span
                        >帮助企业快速发现享惠机会以及享惠空间，最大化应用FTA优惠政策。
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </Col>
        <Col span="6">
          <div
            class="item"
            @mouseenter="currentIdx = 7"
            @mouseleave="currentIdx = 0"
          >
            <img src="~@/assets/images/new_home/ss7.png" alt="" />
            <div class="title lk" @click="goDataBoard">大数据看板</div>
            <div class="desc lk">
              <div @click="goDataBoard">产业分析</div>
              <div @click="goDataBoard">国别分析</div>
            </div>
            <div class="desc lk">
              <div @click="goDataBoard">动态跟踪</div>
              <div @click="goDataBoard">利用研判</div>
            </div>
            <div class="rcep-popup-arrow" v-show="currentIdx == 7"></div>
            <div class="rcep-popup" v-show="currentIdx == 7">
              <div class="funs-main">
                <Row :gutter="60">
                  <Col span="12">
                    <div class="s1">
                      <div class="stitle gnsm ss">功能说明</div>
                      <div class="sdesc num">
                        <span class="sn1">-</span
                        >提高FTA利用率是个持续的过程，一方面各套FTA的协定税率需要5－25年逐步降为零关税，一方面企业尤其中小企业需要一个学习的时间来了解如何应用。
                      </div>
                      <div class="sdesc num">
                        <span class="sn1">-</span
                        >各地政府需要通过及时掌握企业的利用情况和遇到的困难来不断推出有针对性的公共服务，从而持续提高整个区域的FTA利用率。
                      </div>
                      <div class="sdesc num">
                        <span class="sn1">-</span
                        >本系统通过精准统计特定省市或区域的FTA协定关税利用情况，以及优惠贸易往来情况，对特定产业、特定国别、特定FTA协定的利用情况可做综合研判，可为政府制定产业政策提供重要的参考数据。
                      </div>
                    </div>
                  </Col>
                  <Col span="12">
                    <div class="s2">
                      <div class="stitle gnld">功能亮点</div>
                      <div class="sdesc">
                        <b><span>-</span>实时统计。</b
                        ><span>-</span
                        >可精准计算和动态展示特定区域的企业与RCEP成员间的协定关税利用情况，客观分析RCEP为企业带来的经济效率和政策红利。
                      </div>
                      <div class="sdesc">
                        <b><span>-</span>综合比较。</b
                        ><span>-</span
                        >可比较各套FTA的协定关税利用情况，客观分析各套FTA的利用效果。
                      </div>
                      <div class="sdesc">
                        <b><span>-</span>定制化管理。</b
                        ><span>-</span
                        >根据不同地区和地方政府的管理要求，从特定维度进行数据梳理、分析统计，并形成动态数据看板。
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <Row :gutter="50" class="list" style="margin-top: 40px">
        <Col span="6">
          <div
            class="item"
            @mouseenter="currentIdx = 8"
            @mouseleave="currentIdx = 0"
          >
            <img src="~@/assets/images/new_home/ss8.png" alt="" />
            <div class="title lk" @click="$router.push({ name: 'Mobile' })">
              移动端助手
            </div>
            <div class="desc lk">
              <div @click="$router.push({ name: 'Mobile' })">灵活对接</div>
              <div @click="$router.push({ name: 'Mobile' })">贸易资讯</div>
            </div>
            <div class="desc lk">
              <div @click="$router.push({ name: 'Mobile' })">综合查询</div>
              <div @click="$router.push({ name: 'Mobile' })">实时更新</div>
            </div>
            <div class="rcep-popup-arrow" v-show="currentIdx == 8"></div>
            <div class="rcep-popup" v-show="currentIdx == 8">
              <div class="funs-main">
                <Row :gutter="60">
                  <Col span="12">
                    <div class="s1">
                      <div class="stitle qyxq">企业需求</div>
                      <div
                        class="sdesc"
                        style="text-indent: 30px;padding-left: 0;left: -12px;"
                      >
                        对于外贸企业而言，需要一款可以随时随地查询海关政策和法规的工具。现存的外贸信息发布平台繁多、良莠不齐，且查询方式不尽相同，企业需要登录不同的平台来查询不同信息。企业需要一款一站式查询工具，提供最新最全的外贸信息综合查询服务。
                      </div>
                      <div class="stitle gnsm" style="margin-top: 20px;">
                        功能说明
                      </div>
                      <div class="sdesc num">
                        <span class="sn1">-</span
                        >提供移动端小程序、公众号、手机APP等多种形式的查询工具。
                      </div>
                      <div class="sdesc num">
                        <span class="sn1">-</span
                        >可做为web端平台的配套移动工具，也可以独立做为移动端的查询应用工具。
                      </div>
                      <div class="sdesc num">
                        <span class="sn1">-</span
                        >针对RCEP和中国已经实施的20套FTA提供协定税率的综合查询与最低税率推荐服务。
                      </div>
                      <div class="sdesc num">
                        <span class="sn1">-</span
                        >企业可查询最新的进出口税费、监管证件与贸易管制等政策法规信息。具体包括智能归类、税率查询、原产地查询、涉证涉检、中美加征、反倾销反补贴查询、CIQ查询、3C查询、出口退税、消费税率、海关汇率等信息的查询。
                      </div>
                    </div>
                  </Col>
                  <Col span="12">
                    <div class="s2">
                      <div class="stitle gnld">功能亮点</div>
                      <div class="sdesc">
                        <b><span>-</span>灵活对接。</b
                        ><span>-</span
                        >根据政府或企业需求，可以便捷对接官网、公众号以及其它现存系统。
                      </div>
                      <div class="sdesc">
                        <b><span>-</span>税则转版。</b
                        ><span>-</span
                        >通过海关专家团队对各国税则的专业分析，按照各FTA成员国的最新进出口税号匹配最优税率。RCEP的降税清单是各成员国基于2012年谈判时的税则版本，与2022年实施的最新税则相比已产生了巨大差异，很多原税号已经没有或者变更。本系统对所有FTA税则进行转版和税号更新，降低企业查询难度，提高查询准确性。
                      </div>
                      <div class="sdesc">
                        <b><span>-</span>实时数据。</b
                        ><span>-</span
                        >系统提供了最新的海关税则税率与原产地规则信息，并及时维护，所有信息与海关同步更新。
                      </div>
                      <div class="sdesc">
                        <b><span>-</span>大数据智能归类。</b
                        ><span>-</span
                        >基于上亿条的历史申报信息，为企业提供最真实最贴切的归类建议，将原本专业复杂的归类工作变的轻松简单。通过归类案例和商品申报要素的信息提醒，为企业精准归类提供数据支持。
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </Col>
        <Col span="6">
          <div class="item">
            <a class="title lk" href="/appExample">
              <img src="~@/assets/images/yingyongshili.png" alt="" />
              <div class="title lk">RCEP应用实例</div>
              <div class="desc lk">
                <div>功能展示</div>
                <div>行业经验</div>
              </div>
              <div class="desc lk">
                <div>案例教程</div>
                <div>最佳实践</div>
              </div>
            </a>
          </div>
        </Col>

        <Col span="6">
          <div class="item">
            <a class="title lk" href="/ftaList">
              <img src="~@/assets/images/fta-text.png" alt="" />
              <div class="title lk">协定文本</div>
              <div class="desc lk">
                <div>内容齐全</div>
                <div>货贸规则</div>
              </div>
              <div class="desc lk">
                <div>服贸规则</div>
                <div>实时更新</div>
              </div>
            </a>
          </div>
        </Col>
        <Col span="6">
          <div class="item">
            <img src="~@/assets/images/chukouguanzhi.png" alt="" />
            <a
              class="title lk"
              target="_blank"
              href="https://fairtrade.sww.sh.gov.cn/action/lsp/export_exObject"
            >
              <div class="title lk">出口管制</div>
              <div class="desc lk">
                <div>政策法规</div>
                <div>信息查询</div>
              </div>
              <div class="desc lk">
                <div>限制清单</div>
                <div>实时更新</div>
              </div>
            </a>
          </div>
        </Col>
      </Row>

      <Row :gutter="50" class="list" style="margin-top: 40px">
        <Col span="6">
          <div class="item">
            <img src="~@/assets/images/zhinengguilei.png" alt="" />
            <a class="title lk" href="/classify/classifylist">
              <div class="title lk">智能归类</div>
              <div class="desc lk">
                <div>先例归类</div>
                <div>自动匹配</div>
              </div>
              <div class="desc lk">
                <div>最优推荐</div>
                <div>实时更新</div>
              </div>
            </a>
          </div>
        </Col>
        <Col span="6">
          <div class="item">
            <img src="~@/assets/images/zmjz.png" alt="" />
            <a class="title lk" target="_blank">
              <div
                class="title lk"
                @click="
                  $router.push({
                    name: 'queryRateLevy',
                    params: { exporter: 1, importer: 1, hscode: 1 }
                  })
                "
              >
                中美加征
              </div>
            </a>
          </div>
        </Col>
      </Row>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapState: mapDataState } = createNamespacedHelpers("data");

export default {
  name: "HomeS1",
  data() {
    return {
      currentIdx: 0
    };
  },
  computed: {
    ...mapDataState({
      importerAll: state => state.importerAll
    })
  },
  methods: {
    gotoHs() {
      // if (this.importerAll.length) {
      // let zg = _.find(this.importerAll, o => /中国/i.test(o.name))
      // if (zg) {
      //   this.$router.push({ name: 'queryHsCode', params: { importer: zg.id, hscode: 1 } })
      // } else {
      //   this.$router.push({ name: 'queryHsCode', params: { importer: this.importerAll[0].id, hscode: 1 } })
      // }
      // this.$router.push({ name: 'queryHsCode', params: { importer: 1, hscode: 1 } })
      // } else {
      this.$router.push({ name: "queryHsCode", params: { hscode: 1 } });
      // }
    },
    goDataBoard() {
      window.open("/static/signboard-all/index.html", "_blank");
    }
  }
};
</script>

<style scoped>
.main-component {
  text-align: center;
  background-color: #f6fafe;
}
.main-component.homes1 .wrap {
  /* max-width: 880px; */
}
.list .item {
  /* width: 200px; */
  margin: 0 auto;
  padding: 25px 20px 20px;
  background-color: #fff;
  box-shadow: 0 2px 4px 2px rgba(233, 233, 233, 0.9);
}
.list .item img {
  width: 90px;
  height: 104.2px;
  margin: 0 auto 20px;
}
.list .item .title {
  color: #333;
  font-weight: bold;
  font-size: 16px;
  margin: 0 0 16px;
}
.list .item .title.lk {
  cursor: pointer;
}
.list .item .title.lk:hover {
  color: #ffa000;
}
.list .item .desc {
  color: #666;
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-bottom: 12px;
  font-size: 14px;
  font-weight: normal;
}
.list .item .desc.lk {
  cursor: pointer;
}
.list .item .desc.lk div:hover {
  color: #ffa000;
}
.list >>> .ivu-poptip,
.list >>> .ivu-poptip-rel {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/home/S1.vue